import { ReactNode, useMemo } from 'react'

import { Flex } from 'antd'
import { Icon, T, Tooltip } from 'govwell-ui'
import { EntityFieldFragment } from 'types/graphql'

import { ColumnData, FieldValueTable } from 'src/components/shared/FieldValueTable'

type Props = {
  fields: EntityFieldFragment[]
  label: ReactNode
}

const EntityVersionFieldsTooltipContent = (props: Props) => {
  const { fields } = props

  const data: ColumnData[] = useMemo(
    () =>
      fields?.map((f) => ({
        fieldName: f.entityFieldTemplate?.label || '',
        key: `${f.id}`,
        fieldValue: f.stringifiedValue || '',
      })),
    [fields]
  )

  return (
    <Flex gap={4}>
      <T.Body className="text-neutral-500">{props.label} </T.Body>
      <Tooltip
        content={
          <>
            <T.BodyLarge>
              This information was imported from a GIS database that is integrated with GovWell and
              will be attached to your submittal.
            </T.BodyLarge>
            <FieldValueTable data={data} />
          </>
        }
        contentClassName="max-w-[min(90vw,_600px)] p-6"
        asChild={false}
      >
        <T.Body className="text-green-600">
          <Icon.FaLink />
        </T.Body>
      </Tooltip>
    </Flex>
  )
}

export default React.memo(EntityVersionFieldsTooltipContent)
